import { GemshellBackend, LocalStorageBackend, StorageBackend } from "./backends";

export type SaveSystem = {
  save: (key: string, data: any) => Promise<void> | void;
  load: (key: string, initialState: any) => Promise<any>;
  clear: () => Promise<void>;
};


export const SuperSaveSystem = (): SaveSystem => {
  let instance: SaveSystem | null = (window as any).super_save_system || null;

  if (instance) {
    return instance;
  }

  const backendType = import.meta.env.VITE_SAVE_BACKEND || 'local';
  let backend: StorageBackend | null = null;


  if (backendType === 'local') {
    backend = new LocalStorageBackend();
  } else if (backendType === 'gemshell') {
    backend = new GemshellBackend();

  } else {
    throw new Error('Invalid backend type');
  }

  instance = {
    save: async (key: string, data: any) => {
      await Promise.resolve(backend?.save(key, data));
    },
    load: (key: string, initialState: any) => backend!.load(key, initialState),
    clear: async () => {
      await Promise.resolve(backend?.clear());
    },
  };

  (window as any).super_save_system = instance;

  return instance;
};
